/**
 * Repository for obtaining Entities by their ID or as a list
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

import { Repository } from "./Repository.js";

export class TimelineRepository extends Repository {

    constructor() {
		super();
        this.map = {};
		this.list = [];
		this.orderedList = [];
    }
	
	register(timeline) {
		this.map [timeline.getID()] = timeline;
		this.list.push(timeline);

		if (timeline.getActive()) {
			this.orderedList.unshift(timeline);
		} else {
			this.orderedList.push(timeline);
		}
	}

	getOrderedList() {
		return this.orderedList;
	}

	sortAndAnotate() {
		for (let i = 0; i < this.orderedList.length; i++) {
			this.orderedList [i].sortAndAnotate();
		}
	}

}